<!--
 * @name: 设备监面板
 * @description: 设备监面板(注意：实时监控存在权限问题)
 * @author: huizi(huizi.li@shengyc.com)
 * @Date: 2019-10-14 09:49:34
 * @LastEditTime: 2022-10-26 10:31:46
 -->

<template>
  <div class="panel-container">
    <div
      :style="{
        width: '100%',
        height: `calc(100vh - 11.73333vmin)`
      }"
    >
      <section class="new-real-time-container">
        <v-touch
          v-on:pan="pan($event)"
          v-on:panstart="panstart($event)"
          v-on:panmove="panmove($event)"
          v-on:pinchin="pinchin($event)"
          v-on:pinchout="pinchout($event)"
          v-on:pinchstart="pinchstart($event)"
          style="width: 100%; height: 100%"
        >
          <section
            class="new-real-time-content"
            ref="content"
            v-if="tip === 'success'"
            @touchstart="touchstart"
            @touchmove="touchmove"
            @touchend="touchend"
            @mousewheel.prevent="handleScroll"
            @keydown.space.prevent
            tabindex="1"
          >
            <section
              class="scale-container"
              ref="scaleContainer"
              v-viewer="options"
              :style="{ transform: `scale(${scaleNum})` }"
            >
              <div
                class="component-data-container"
                v-for="(item, index) in comDataList"
                :key="index"
                :style="computedComDataStyle(item)"
                @click="openDialog(item)"
              >
                <div class="component-data-content">
                  <div class="com-img-container" v-if="item.type === 'img'">
                    <img
                      :src="computedImg(item.img, $event)"
                      draggable="false"
                    />
                  </div>
                  <div
                    class="com-img-container"
                    v-else-if="item.type === 'dynamic'"
                  >
                    <img
                      :src="computedImg(item.default)"
                      draggable="false"
                      v-if="item.selectRule == null"
                    />
                    <el-popover
                      placement="top"
                      trigger="hover"
                      :content="
                        `${item.rules[item.selectRule].point.name}${
                          item.rules[item.selectRule].condition
                        }${item.rules[item.selectRule].value}`
                      "
                      popper-class="my-popover"
                      v-else
                    >
                      <img
                        slot="reference"
                        :src="computedImg(item.rules[item.selectRule].img)"
                        draggable="false"
                      />
                    </el-popover>
                  </div>
                  <div
                    class="com-img-container"
                    v-else-if="item.type === 'status'"
                  >
                    <img
                      :src="
                        require(`../../assets/images/status-${item.default}-${item.border}.png`)
                      "
                      draggable="false"
                      v-if="item.selectRule == null"
                    />
                    <el-popover
                      placement="top"
                      trigger="hover"
                      :content="
                        `${item.rules[item.selectRule].point.name}${
                          item.rules[item.selectRule].condition
                        }${item.rules[item.selectRule].value}`
                      "
                      popper-class="my-popover"
                      v-else
                    >
                      <img
                        slot="reference"
                        :src="
                          require(`../../assets/images/status-${
                            item.rules[item.selectRule].color
                          }-${item.border}.png`)
                        "
                        draggable="false"
                      />
                    </el-popover>
                  </div>
                  <div
                    class="com-text-container"
                    v-else-if="item.type === 'dynamicText'"
                  >
                    <div
                      class="com-text-content"
                      v-if="item.selectRule == null"
                    >
                      <span>{{ item.text }}</span>
                    </div>
                    <el-popover
                      placement="top"
                      trigger="hover"
                      :content="
                        `${item.rules[item.selectRule].point.name}${
                          item.rules[item.selectRule].condition
                        }${item.rules[item.selectRule].value}`
                      "
                      popper-class="my-popover"
                      v-else
                    >
                      <div class="com-text-content" slot="reference">
                        <span>{{ item.rules[item.selectRule].text }}</span>
                      </div>
                    </el-popover>
                  </div>
                  <div
                    class="com-text-container"
                    v-else-if="item.type === 'number'"
                  >
                    <div class="com-text-content">
                      <span>{{ computedNumber(item) }}</span>
                    </div>
                  </div>
                  <div
                    class="com-border-container"
                    v-else-if="item.type === 'border' || item.type === 'jump'"
                  ></div>
                  <div
                    class="com-text-container"
                    v-else-if="item.type === 'text'"
                  >
                    <div class="com-text-content">
                      <span>{{ item.content }}</span>
                    </div>
                  </div>
                  <div
                    class="com-img-container"
                    v-else-if="item.type === 'line'"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
                      <path
                        :d="`M 0 0 L ${item.width} ${item.height}`"
                        :stroke-width="item.borderWidth"
                        :stroke="item.borderColor"
                        :stroke-dasharray="item.borderStyle"
                      />
                    </svg>
                  </div>
                  <div
                    class="com-text-container"
                    v-else-if="
                      item.type === 'button' || item.type === 'dynamicText'
                    "
                  >
                    <div class="com-text-content">
                      <span>{{ item.text }}</span>
                    </div>
                  </div>
                  <div
                    class="com-chart-container"
                    v-else-if="item.type === 'switch'"
                  >
                    <div class="chart-title-container">
                      <div class="chart-title">
                        <span>{{ item.title }}</span>
                      </div>
                      <div class="time-select-wrap">
                        <time-select
                          @change="reqSwitchLine(index, $event)"
                          :comDataList="comDataList"
                        ></time-select>
                      </div>
                    </div>
                    <div
                      class="com-img-container"
                      :style="{
                        height: `calc(100% - ${Number(item.fontSize) + 10}px)`
                      }"
                    >
                      <!-- 曲线 -->
                      <ve-line
                        v-if="chartComObj[index].tip === 'success'"
                        :extend="switchLine.chartExtend"
                        :tooltip="switchLine.tooltip"
                        :grid="switchLine.grid"
                        :xAxis="chartComObj[index].xAxis"
                        :yAxis="switchLine.yAxis"
                        :series="chartComObj[index].series"
                        :colors="[item.color]"
                        height="100%"
                      ></ve-line>
                      <no-data :tip="chartComObj[index].tip" v-else></no-data>
                    </div>
                  </div>
                  <div
                    class="com-chart-container"
                    v-else-if="item.type === 'trendline'"
                  >
                    <div class="chart-title-container">
                      <div class="chart-title">
                        <span>{{ item.title }}</span>
                      </div>
                      <div class="time-select-wrap">
                        <time-select
                          @change="reqTrendLine(index, $event)"
                        ></time-select>
                        <!-- <quick-time @change="reqTrendLine(index, $event)"></quick-time> -->
                      </div>
                    </div>
                    <div
                      class="com-img-container"
                      :style="{
                        height: `calc(100% - ${Number(item.fontSize) + 10}px)`
                      }"
                    >
                      <ve-line
                        v-if="chartComObj[index].tip === 'success'"
                        :extend="trendlineChart.chartExtend"
                        :grid="trendlineChart.grid"
                        :xAxis="chartComObj[index].xAxis"
                        :yAxis="trendlineChart.yAxis"
                        :series="chartComObj[index].series"
                        :colors="item.colorList"
                        :legend="trendlineChart.legend"
                        height="100%"
                      ></ve-line>
                      <no-data :tip="chartComObj[index].tip" v-else></no-data>
                    </div>
                  </div>
                  <div
                    class="com-chart-container"
                    v-else-if="item.type === 'capacity'"
                  >
                    <div class="chart-title-container">
                      <div class="chart-title">
                        <span>{{ item.title }}</span>
                      </div>
                    </div>
                    <div
                      class="com-img-container"
                      :style="{
                        height: `calc(100% - ${item.fontSize + 10}px)`
                      }"
                    >
                      <div
                        :class="[
                          'com-capacity-container',
                          item.sortType === 'vertical' ? 'column' : ''
                        ]"
                      >
                        <div
                          class="com-capacity-item"
                          v-for="(dim, dimIndex) in item.dimension"
                          :key="dimIndex"
                          :style="dimStyle(item)"
                        >
                          <span>{{ `${capacityDim[dim]}产能` }}</span>
                          <div
                            class="com-capacity-content"
                            :style="{
                              height: `calc(100% - ${item.fontSize + 10}px)`,
                              'background-color': item.backgroundColor
                            }"
                          >
                            <p v-if="capacityTip === 'loading'">
                              <i class="el-icon-loading"></i>
                            </p>
                            <p v-else>
                              {{ computedData(capacityData, index, dim) }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <transform-pie
                    class="com-chart-container"
                    v-else-if="item.type === 'pie'"
                    :graph="item"
                    :realTimeData="realTimeData"
                  ></transform-pie>
                  <transform-board
                    v-else-if="item.type === 'board'"
                    :graph="item"
                    :realTimeData="realTimeData"
                  ></transform-board>
                  <transform-histogram
                    v-else-if="item.type === 'histogram'"
                    :graph="item"
                    :realTimeData="realTimeData"
                    :id="id"
                  ></transform-histogram>
                  <transform-graph
                    v-else-if="item.type === 'graph'"
                    :graph="item"
                    :realTimeData="realTimeData"
                    :id="id"
                  ></transform-graph>
                </div>
              </div>
            </section>
          </section>
          <no-data :tip="tip" v-else></no-data>
        </v-touch>
        <!-- <div class="scale-adjust-container" v-if="tip === 'success'">
          <span>缩放：</span>
          <el-input-number
            size="mini"
            class="h100"
            v-model="scaleNumPercent"
            :controls="false"
            :min="10"
            :max="200"
            :precision="0"
            @change="changeScale"
          ></el-input-number>
          <span class="percent">%</span>
        </div>-->
        <el-dialog
          :visible.sync="btnDialogShow"
          width="270px"
          :before-close="closeBtnDialog"
          :show-close="false"
          top="38vh"
          class="issue-dialog"
          :modal-append-to-body="false"
        >
          <div class="dialog-container">
            <div class="dialog-header">
              <span>请输入下发值</span>
            </div>
            <div class="dialog-content">
              <div class="add-select-container">
                <div class="var-container">
                  <span
                    >当前变量：{{
                      btnItem.rules ? btnItem.rules[0].point.name : ''
                    }}</span
                  >
                </div>
                <div class="var-container">
                  <span
                    >数据类型：{{
                      btnItem.rules ? btnItem.rules[0].point.type : ''
                    }}</span
                  >
                </div>
                <!-- <el-input-number
                                    :controls="false"
                                    v-model="btnValue"
                                ></el-input-number> -->
                <el-input
                  v-number-input.float="6"
                  v-model="btnValue"
                  @blur="formatValue"
                  v-if="
                    btnItem.rules &&
                      (btnItem.rules[0].point.type === 'float' ||
                        btnItem.rules[0].point.type === 'double')
                  "
                  size="small"
                >
                </el-input>
                <!-- int类型 -->
                <el-input
                  v-number-input.float="0"
                  v-model="btnValue"
                  v-else-if="
                    btnItem.rules && btnItem.rules[0].point.type === 'int'
                  "
                  size="small"
                >
                </el-input>
                <!-- string类型 -->
                <el-select
                  v-model="btnValue"
                  v-else-if="
                    btnItem.rules && btnItem.rules[0].point.type === 'boolean'
                  "
                  size="small"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <!-- string类型 -->
                <el-input v-model="btnValue" v-else size="small"> </el-input>
              </div>
              <div class="btn-group add">
                <el-button @click="closeBtnDialog">取消</el-button>
                <el-button
                  class="save"
                  @click="setBtnNum(btnItem.rules[0].point.type)"
                  :loading="btnLoading"
                >
                  确 定
                </el-button>
              </div>
            </div>
          </div>
        </el-dialog>
        <el-dialog
          :visible.sync="tipDialogShow"
          width="270px"
          :show-close="false"
          top="38vh"
          class="issue-dialog"
          :modal-append-to-body="false"
        >
          <div class="dialog-container tip-dialog">
            是否确定下发数据？
          </div>
          <div class="tip-btn-gruop">
            <el-button @click="closeTipDialog">取消</el-button>
            <el-button
              @click="tipConfirm"
              type="primary"
              class="save"
              :loading="tipLoading"
            >
              确 定
            </el-button>
          </div>
        </el-dialog>
      </section>
    </div>
  </div>
</template>

<script>
import Big from 'big.js';
import NoData from '@/components/common/noData.vue';
import TimeSelect from './timeSelect.vue';
import moment from 'moment';
import { getUrlKey } from '@/config/Utils';
import {
  get_equipment_info,
  get_monitor_capacity,
  get_statistic,
  get_monitor_status,
  get_data_device,
  get_statistic_eqm_monitor_v2_timeserial,
  issueSave
} from '@/service/getData';
import transformPie from './transformPie.vue';
import transformBoard from './transformBoard.vue';
import transformHistogram from './transformHistogram.vue';
import transformGraph from './transformGraph.vue';
// import quickTime from './quick-time.vue';

export default {
  name: 'MonitoringDetailsScreen',
  components: {
    NoData,
    TimeSelect,
    transformPie,
    transformBoard,
    transformHistogram,
    transformGraph,
    // quickTime
  },
  data() {
    return {
      toggleScreenIcon: '',
      orientation: 0,
      timer: '',
      pageX: false,
      pageY: false,
      initX: false,
      initY: false,
      scale: 0,
      secureScale: 0,
      capacityTip: 'loading',
      tip: 'loading',
      scaleNum: 1,
      scaleNumPercent: 100,
      // comDataList: [],
      btnDialogShow: false,
      btnItem: {},
      btnValue: undefined,
      // Viewer 图片放大
      options: {
        url: 'src',
        inline: false,
        button: true,
        navbar: false,
        title: false,
        toolbar: false,
        tooltip: true,
        movable: false,
        zoomable: false,
        rotatable: false,
        scalable: false,
        transition: true,
        fullscreen: true,
        keyboard: false,
        filter(image) {
          return image.src && !image.src.includes('default-img');
        }
      },
      switchLine: {
        chartExtend: {
          series: {
            smooth: false
          }
        },
        tooltip: {
          trigger: 'axis',
          formatter: params => {
            params = params[0];
            let str = '';
            switch (params.value) {
              case 0:
                str = '停机';
                break;
              case 1:
                str = '运行';
                break;
              case 2:
                str = '异常';
                break;
            }
            return `${params.seriesName}<br />${params.name}：${str}`;
          }
        },
        grid: {
          top: '5%',
          left: '3%',
          right: '4%',
          bottom: '4%'
        },
        xAxis: {
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: '#ddd',
              width: 2
            },
            show: true,
            onZero: false
          },
          axisLabel: {
            color: '#333'
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#566472',
              width: 2
            },
            show: true
          },
          data: []
        },
        yAxis: {
          axisLine: {
            lineStyle: {
              color: '#fffefe'
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#666'
            }
          },
          minInterval: 1,
          min: -0.2,
          axisLabel: {
            formatter: value => {
              switch (value) {
                case 0:
                  return '停机';
                case 1:
                  return '运行';
                case 2:
                  return '异常';
                default:
                  return '';
              }
            },
            color: value => {
              switch (value) {
                case '0':
                  return '#f3b745';
                case '1':
                  return '#659ff6';
                case '2':
                  return '#f98545';
              }
            }
          }
        },
        series: [
          {
            name: '状态',
            type: 'line',
            showSymbol: false,
            lineStyle: {
              width: 3
            },
            data: []
          }
        ]
      },
      trendlineChart: {
        chartExtend: {
          series: {
            smooth: false
          }
        },
        grid: {
          top: '14%',
          left: '3%',
          right: '4%',
          bottom: '4%'
        },
        legend: {
          textStyle: {
            color: '#333'
          },
          right: '3%',
          top: 0,
          type: 'scroll',
          pageTextStyle: {
            color: '#333'
          }
        },
        xAxis: {
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: '#ddd',
              width: 2
            },
            show: true
          },
          axisLabel: {
            color: '#333'
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#566472',
              width: 2
            },
            show: true
          },
          data: []
        },
        yAxis: {
          axisLine: {
            lineStyle: {
              color: '#333'
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#666'
            }
          }
        }
      },
      capacityDim: {
        day: '日',
        month: '月',
        season: '季',
        year: '年'
      },
      capacityData: [
        {
          day: 0,
          month: 0,
          season: 0,
          year: 0
        }
      ],
      chartComObj: {},
      tempBtnVal: {},
      btnLoading: false,
      tipDialogShow: false,
      tipItem: {},
      tokenByRn: '',
      tipLoading: false
    };
  },
  props: {
    id: {
      //设备id
      type: String,
      required: true
    },
    realTimeData: {
      type: Object,
      default: () => {}
    },
    timestamp: {
      // 历史时间戳
      type: Number,
      default: Date.now()
    },
    mode: {
      // 模式： 1：实时模式 2：历史模式
    },
    comDataList: {
      type: Array,
      default: () => []
    }
  },
  created() {
    // let url = window.location.href;
    // let paramsUrl = url.substr(url.indexOf('?') + 1);
    // let paramsArr = paramsUrl.split('&'); //各个参数放到数组里
    // console.log(getUrlKey(location.host+'token'));
    // console.log(getUrlKey('equipment_id'));
    // console.log(getUrlKey('isHeader'));
    // paramsArr.map(val => {
    //   let num = val.split('=');
    //   if (num && num.length > -1) {
    //     if (num[0] === location.host+'token') {
    //       this.tokenByRn = num[1];
    //     }
    //     if (num[0] === 'equipment_id') {
    //       this.f = num[1];
    //     }
    //     if (num[0] === 'isHeader') {
    //       this.equipment_id_byRn = num[1];
    //     }
    //   }
    // });
    this.tokenByRn = getUrlKey('token');
  },
  mounted() {
    // this.equipment_id_byRn = getUrlKey('equipment_id');
    // this.tokenByRn = getUrlKey('token');
    // if (getUrlKey('isHeader')) {
    //   this.$emit('isHeader', getUrlKey('isHeader'));
    // }
    // this.getRealtimeData();
    this.$_getData();
    // clearInterval(this.timer);
    // this.timer = setInterval(() => {
    //   this.getRealtimeData();
    // }, 5000);
    window.addEventListener(
      'onorientationchange' in window ? 'orientationchange' : 'resize',
      this.$_hengshuping,
      false
    );
  },
  methods: {
    $_hengshuping() {
      if (window.orientation == 180 || window.orientation == 0) {
        this.emit('getData');
      }
      if (window.orientation == 90 || window.orientation == -90) {
        this.emit('getData');
      }
    },
    computedData(data, index, dim) {
      if (data[index] != undefined && data[index][dim] != undefined) {
        return data[index][dim];
      } else {
        return '暂无数据';
      }
    },
    pan(e) {
      this.initX = e.center.x;
      this.initY = e.center.y;
    },
    panstart(e) {
      // console.log('panstart');
      // console.log(e);
      // console.log(this.$refs.content);
      // console.log('???', this.$refs.content.scrollLeft);
      // this.initX = e.center.x;
      // this.initY = e.center.y;
    },
    panmove(e) {
      this.$refs.content.scrollLeft =
        this.$refs.content.scrollLeft - (e.center.x - this.initX);
      this.$refs.content.scrollTop =
        this.$refs.content.scrollTop - (e.center.y - this.initY);
    },
    pinchstart(e) {
      this.scale = e.scale;
    },
    pinchout(e) {
      let scaleNum = new Big(this.scaleNum);
      let scaleMax; //获取最大缩放比
      const scaleWidth =
        this.$refs.content.clientWidth / this.$refs.scaleContainer.clientWidth;
      const scaleHeight =
        this.$refs.content.scrollHeight /
        this.$refs.scaleContainer.scrollHeight;
      scaleMax = scaleWidth > scaleHeight ? scaleWidth : scaleHeight;

      if (e.scale) {
        this.scaleNum = Number(scaleNum.plus(0.01));
        if (this.scaleNum > scaleMax) {
          this.scaleNum = scaleMax;
        }
      }
    },
    pinchin(e) {
      let scaleNum = new Big(this.scaleNum);
      if (e.scale) {
        this.scaleNum = Number(scaleNum.minus(0.01));
        if (this.scaleNum < this.secureScale) {
          this.scaleNum = this.secureScale;
          this.$refs.content.scrollLeft = 0;
        }
      }
    },
    // zoom(e) {
    //   // console.log('zoom');
    //   // console.log(e);
    // },
    openDialog(item) {
      let type = item.type;
      if (type === 'button') {
        let buttonType = item.buttonType;
        if (item.rules.length === 0) {
          return;
        }
        if (buttonType === 'constant') {
          this.tipItem = item;
          if (item.remind) {
            // this.$confirm('是否确定下发数据？', {})
            //     .then(() => {
            //          this.pressButton(item);

            //     })
            //     .catch(() => {});
            this.tipDialogShow = true;
          } else {
            this.pressButton(item);
          }
        } else {
          this.btnValue = this.tempBtnVal[item.rules[0].point.id];
          this.btnItem = item;
          this.btnDialogShow = true;
        }
      }
      // if (type === 'number' && item.point) {
      //     this.$store.commit('openDialog', {
      //         title: this.$t('dialog.monitor.line'),
      //         component: 'TrendLine',
      //         field: item.point.name,
      //         btn: true,
      //         id: this.id,
      //     });
      // } else if (item.selectRule != null) {
      //     this.$store.commit('openDialog', {
      //         title: this.$t('dialog.monitor.line'),
      //         component: 'TrendLine',
      //         field: item.rules[item.selectRule].point.name,
      //         btn: true,
      //         id: this.id,
      //     });
      // } else if (type === 'jump') {
      //     let path = item.path;
      //     let component = item.component;
      //     if (component) {
      //         this.$store.commit('setJump', {
      //             component,
      //         });
      //     }
      //     this.$router.push({
      //         path,
      //     });
      // } else if (type === 'button') {
      //     let buttonType = item.buttonType;
      //     if (item.rules.length === 0) {
      //         return;
      //     }
      //     if (buttonType === 'constant') {
      //         if (item.remind) {
      //             this.$msgbox
      //                 .confirm('是否确定下发数据？', {
      //                     closeOnClickModal: false,
      //                     closeOnPressEscape: false,
      //                 })
      //                 .then(() => {
      //                     this.pressButton(item);
      //                 })
      //                 .catch(() => {});
      //         } else {
      //             this.pressButton(item);
      //         }
      //     } else {
      //         this.btnValue = this.tempBtnVal[item.rules[0].point.id];
      //         this.btnItem = item;
      //         this.btnDialogShow = true;
      //     }
      // }
    },

    computedImg(img) {
      if (!img) {
        // eslint-disable-next-line no-undef
        return require('../../assets/images/default-img.png');
      }
      if (img.indexOf('http') > -1) {
        return img;
      }
      return `${this.$store.state.uploadUrl}&resource_id=${img}`;
    },
    computedNumber(item) {
      let point = item.point;
      if (!point) {
        return '暂无数据';
      }
      // let str = `${item.desc}`;
      let str = `${item.desc}` ? `${item.desc}：` : '';
      let pointData = this.realTimeData[point.name];
      if (pointData == null) {
        str += '暂无数据';
      } else {
        if (point.type === 'string') {
          return (str += pointData);
        }
        let num = Number(pointData);
        if (isNaN(num)) {
          str += '暂无数据';
        } else {
          str += `${num.toFixed(item.littleNum)}${
            point.unit ? point.unit : ''
          }`;
        }
      }
      return str;
    },
    getRealtimeData() {
      get_statistic({
        // token: localStorage.getItem(location.host+'token'),
        // equipment_id: this.equipmentId,
        token: this.tokenByRn
          ? this.tokenByRn
          : localStorage.getItem(location.host + 'token') ||
            'ab95fbf7b8754ef085b66292090b1bf2',
        equipment_id: this.equipment_id_byRn
          ? this.equipment_id_byRn
          : this.equipmentId || '5ef33c04e01b994fc7b4f611',
        date: moment(new Date()).format('YYYY-MM-DD')
      })
        .then(res => {
          if (res) {
            if (res.connectStatus === 0) {
              this.state = 'off';
            } else if (res.connectStatus === 1) {
              if (res.workStatus === 0) {
                this.state = 'stop';
              } else if (res.workStatus === 1) {
                this.state = 'run';
              } else if (res.workStatus === 2) {
                this.state = 'break';
              } else {
                this.state = 'off';
              }
            }
            this.realTimeData = res;
          } else {
            this.state = 'break';
          }
        })
        .catch(err => {});
    },
    $_getData() {
      // get_equipment_info({
      //   // token: localStorage.getItem(location.host+'token'),
      //   // equipment_id: this.equipmentId
      //   token: this.tokenByRn
      //     ? this.tokenByRn
      //     : localStorage.getItem(location.host + 'token'),
      //   equipment_id: this.equipment_id_byRn
      //     ? this.equipment_id_byRn
      //     : this.equipmentId,
      // }).then((res) => {
      // if (!this.comDataList) {
      //   this.tip = 'empty';
      // } else {
      //   let chartObj = {};
      //   this.comDataList.forEach((item, index) => {
      //     let type = item.type;
      //     if (
      //       type === 'dynamic' ||
      //       type === 'status' ||
      //       type === 'dynamicText'
      //     ) {
      //       item.selectRule = undefined;
      //     } else if (type === 'switch') {
      //       let switchLine = this.switchLine;
      //       chartObj[index] = {
      //         xAxis: JSON.parse(JSON.stringify(switchLine.xAxis)),
      //         series: JSON.parse(JSON.stringify(switchLine.series)),
      //         tip: 'loading',
      //       };
      //     } else if (type === 'trendline') {
      //       let trendlineChart = this.trendlineChart;
      //       chartObj[index] = {
      //         xAxis: JSON.parse(JSON.stringify(trendlineChart.xAxis)),
      //         series: [],
      //         tip: 'loading',
      //       };
      //     }
      //   });
      //   this.chartComObj = chartObj;
      //   this.handleData(this.realTimeData);
      //   this.reqCapacity();
      //   this.tip = 'success';
      // this.$nextTick(() => {
      //   let content = this.$refs.content;
      //   if (content) {
      //     this.secureScale =
      //       this.$refs.scaleContainer.clientWidth /
      //       this.$refs.scaleContainer.scrollWidth;
      //     this.scaleNum = this.secureScale;
      //     content.addEventListener('DOMMouseScroll', this.handleScroll);
      //   }
      // });
    },
    reqCapacity() {
      if (this.comDataList.length) {
        this.capacityData = [];
        this.comDataList.map((item, index) => {
          this.capacityData.push({
            day: 0,
            month: 0,
            season: 0,
            year: 0
          });
          if (item.type === 'capacity' && item.point && item.point.id) {
            get_monitor_capacity({
              token:
                getUrlKey('token') ||
                localStorage.getItem(location.host + 'token'),
              field_id: item.point.id
            })
              .then(res => {
                this.capacityData.splice(index, 1, res);
                this.capacityTip = 'success';
              })
              .catch(err => {});
          } else {
            this.capacityTip = 'success';
          }
        });
      }
    },
    touchstart(e) {
      // console.log('touchstart');
      // console.log(e);
      //手指按下时的手指所在的X，Y坐标
      // this.pageX = e.originalEvent.touches[0].pageX;
      // this.pageY = e.originalEvent.touches[0].pageY;
      // //初始位置的X，Y 坐标
      // this.initX = e.target.offsetLeft;
      // this.initY = e.target.offsetTop;
      // //记录初始 一组数据 作为缩放使用
      // if (e.originalEvent.touches.length >= 2) {
      //   //判断是否有两个点在屏幕上
      //   this.start = e.originalEvent.touches; //得到第一组两个点
      // }
      //表示手指已按下
      // isTouch = true;
    },
    touchmove(e) {
      // console.log('touchmove');
      // console.log(e);
      // e.preventDefault();
      // // 一根 手指 执行 目标元素移动 操作
      // // if (e.originalEvent.touches.length == 1 && isTouch) {
      // // }
      // // 2 根 手指执行 目标元素放大操作
      // if (e.originalEvent.touches.length >= 2 && this.isTouch) {
      //   // alert("2")
      //   //得到第二组两个点
      //   // var now = e.originalEvent.touches;
      //   Math.abs(
      //     e.originalEvent.touches[0].pageX - e.originalEvent.touches[1].pageX
      //   );
      //   //当前距离变小， getDistance 是勾股定理的一个方法
      //   // if (getDistance(now[0], now[1]) < getDistance(start[0], start[1])) {
      //   // }
      // }
    },
    touchend(e) {
      // console.log('touchend');
      // console.log(e);
      //将 isTouch 修改为false  表示 手指已经离开屏幕
      // if (isTouch) {isTouch = false;}
    },
    getDistance(p1, p2) {
      var x = p2.pageX - p1.pageX,
        y = p2.pageY - p1.pageY;
      return Math.sqrt(x * x + y * y);
    },
    handleScroll(e) {
      e.preventDefault();
      let scaleNum = new Big(this.scaleNum);
      let scaleMax; //获取最大缩放比
      const scaleWidth =
        this.$refs.content.clientWidth / this.$refs.scaleContainer.clientWidth;
      const scaleHeight =
        this.$refs.content.scrollHeight /
        this.$refs.scaleContainer.scrollHeight;
      scaleMax = scaleWidth > scaleHeight ? scaleWidth : scaleHeight;
      if (e.wheelDelta) {
        if (e.wheelDelta > 0) {
          this.scaleNum = Number(scaleNum.plus(0.1));
          if (this.scaleNum > scaleMax) {
            this.scaleNum = scaleMax;
          }
        } else {
          this.scaleNum = Number(scaleNum.minus(0.1));
          if (this.scaleNum < 0.1) {
            this.scaleNum = 0.1;
          }
        }
      } else if (e.detail) {
        if (e.detail < 0) {
          this.scaleNum = Number(scaleNum.plus(0.1));
          if (this.scaleNum > scaleMax) {
            this.scaleNum = scaleMax;
          }
        } else {
          this.scaleNum = Number(scaleNum.minus(0.1));
          if (this.scaleNum < 0.1) {
            this.scaleNum = 0.1;
          }
        }
      }
    },
    reqTrendLine(index, { start_time, end_time }) {
      let curCom = this.comDataList[index];
      let curChartObj = this.chartComObj[index];
      let rules = curCom.rules;
      if (rules.length === 0) {
        curChartObj.tip = 'empty';
        return;
      }
      curChartObj.tip = 'loading';
      let field = rules.map(rule => {
        return {id: rule.point.id, name: rule.point.name };
      });
      get_statistic_eqm_monitor_v2_timeserial({
        // token: localStorage.getItem(location.host+'token'),
        // equipment_id: this.equipmentId,
        token: getUrlKey('token')
          ? getUrlKey('token')
          : localStorage.getItem(location.host + 'token'),
        equipment_id: this.id,
        // template_id: '5b8748db7e6618c0a144bcdd',
        // query_params: {
        //   from: start_time,
        //   to: end_time,
        //   field: field.join('<>'),
        // },
        start_time,
        end_time,
        field_ids: field
      })
        .then(res => {
          let x = [];
          let data = [];
          rules.forEach((rule, index) => {
            let field = rule.point;
            let name = field.desc || field.name;
            let transformName = field.name;

            let obj = {
              name,
              type: 'line',
              showSymbol: false,
              lineStyle: {
                width: 3
              },
              data: []
            };
            res.forEach(item => {
              if (index === 0) {
                x.push(moment(item.time).format('YYYY-MM-DD HH:mm:ss'));
              }
              let value = item[transformName];
              value = value ? value : 0;
              obj.data.push(value);
            });
            data.push(obj);
          });
          curChartObj.xAxis.data = x;
          curChartObj.series = data;
          if (x.length > 0) {
            curChartObj.tip = 'success';
            return;
          }
          curChartObj.tip = 'empty';
        })
        .catch(err => {});
    },
    reqSwitchLine(index, { start_time, end_time }) {
      let curChartObj = this.chartComObj[index];
      curChartObj.tip = 'loading';
      // 后台返回的数据格式是这个，到时请求后直接将代码复制进去就行，要传的equipment_id就是this.id，start_time和end_time是时间戳
      get_monitor_status({
        // token: localStorage.getItem(location.host+'token'),
        // equipment_id: this.equipmentId,
        token: getUrlKey('token')
          ? getUrlKey('token')
          : localStorage.getItem(location.host + 'token'),
        equipment_id: this.id,
        // start_time: moment(new Date()).format('YYYY-MM-DD'),
        // end_time: moment(new Date()).format('YYYY-MM-DD')
        start_time,
        end_time
      })
        .then(res => {
          if (res.length === 0) {
            curChartObj.tip = 'empty';
            return;
          }
          let data = [];
          curChartObj.xAxis.data = res.map((dateItem, dateIndex) => {
            data[dateIndex] = dateItem.value;
            return dateItem.date;
          });
          curChartObj.series[0].data = data;
          curChartObj.tip = 'success';
        })
        .catch(err => {
           curChartObj.tip = 'empty';
        });
    },
    handleData(val) {
      this.comDataList.forEach(item => {
        if (
          item.type === 'status' ||
          item.type === 'dynamic' ||
          item.type === 'dynamicText'
        ) {
          let flag = false;
          for (let rule of item.rules) {
            let value = val[rule.point.name];
            if (value != null) {
              if (rule.condition === '>') {
                if (value > rule.value) {
                  item.selectRule = item.rules.indexOf(rule);
                  flag = true;
                  break;
                }
              } else if (rule.condition === '>=') {
                if (value >= rule.value) {
                  item.selectRule = item.rules.indexOf(rule);
                  flag = true;
                  break;
                }
              } else if (rule.condition === '<') {
                if (value < rule.value) {
                  item.selectRule = item.rules.indexOf(rule);
                  flag = true;
                  break;
                }
              } else if (rule.condition === '<=') {
                if (value <= rule.value) {
                  item.selectRule = item.rules.indexOf(rule);
                  flag = true;
                  break;
                }
              } else if (rule.condition === '=') {
                if (value == rule.value) {
                  item.selectRule = item.rules.indexOf(rule);
                  flag = true;
                  break;
                }
              } else if (rule.condition === '!=') {
                if (value != rule.value) {
                  item.selectRule = item.rules.indexOf(rule);
                  flag = true;
                  break;
                }
              }
            }
          }
          if (!flag) {
            item.selectRule = undefined;
          }
        }
      });
    },
    computedComDataStyle(items) {
      // let devicePixelRatio = window.devicePixelRatio;
      // console.log('遍历数据' + item);
      // let screenW = window.screen.width;
      // let scale = 1200 / window.screen.width;
      // let scale = 1200 / window.screen.width;
      // let scale = 1200 / window.screen.width;

      // let item = Object.assign({}, items, {
      //   top: (items.top * scale) / devicePixelRatio,
      //   left: (items.left * scale) / devicePixelRatio,
      //   width: (items.width * scale) / devicePixelRatio
      // });
      let item = Object.assign({}, items, {
        top: items.top,
        left: items.left,
        width: items.width
      });
      let type = item.type;
      let style = {
        top: `${item.top}px`,
        left: `${item.left}px`,
        width: `${item.width}px`
      };
      if (
        type === 'img' ||
        type === 'dynamic' ||
        type === 'status' ||
        type === 'switch' ||
        type === 'trendline'
      ) {
        Object.assign(style, {
          height: `${item.height}px`
        });
        if (type === 'switch' || type === 'trendline') {
          style.fontSize = `${item.fontSize}px`;
        }
      } else if (
        type === 'number' ||
        type === 'text' ||
        type === 'button' ||
        type === 'dynamicText'
      ) {
        Object.assign(style, {
          color: item.color,
          backgroundColor:
            item.borderRadius === -1 ? 'transparent' : item.backgroundColor,
          fontSize: `${item.fontSize}px`,
          borderRadius: `${item.borderRadius}px`,
          fontWeight: item.fontWeight,
          textDecoration: item.textDecoration
        });
        if (type === 'text') {
          delete style.backgroundColor;
          delete style.borderRadius;
        } else if (type === 'dynamicText' && item.selectRule != null) {
          let targetRule = item.rules[item.selectRule];
          Object.assign(style, {
            color: targetRule.color,
            backgroundColor:
              item.borderRadius === -1
                ? 'transparent'
                : targetRule.backgroundColor
          });
        }
      } else if (type === 'border') {
        Object.assign(style, {
          height: `${item.height}px`,
          borderWidth: `${item.borderWidth}px`,
          borderStyle: item.borderStyle,
          borderColor: item.borderColor,
          backgroundColor: item.backgroundColor
        });
      } else if (type === 'jump') {
        Object.assign(style, {
          height: `${item.height}px`,
          borderRadius: item.borderRadius,
          backgroundColor: item.backgroundColor
        });
      } else if (type === 'line') {
        Object.assign(style, {
          height: `${item.height}px`,
          transform: `matrix(${item.horizontal}, 0, 0, ${item.vertical}, 0, 0)`
        });
      } else if (type === 'capacity') {
        Object.assign(style, {
          height: `${item.height}px`,
          fontSize: `${item.fontSize}px`,
          color: item.color
        });
      }
      return style;
    },
    handlerComDataList() {
      let chartObj = {};
      this.comDataList.forEach((item, index) => {
        let type = item.type;
        if (type === 'dynamic' || type === 'status' || type === 'dynamicText') {
          item.selectRule = undefined;
        } else if (type === 'switch') {
          let switchLine = this.switchLine;
           switchLine.tooltip = {
                        trigger: 'axis',
                        formatter: params => {
                            params = params[0]
                            let str = ''
                            switch (params.value) {
                                case 0:
                                    str = item.downDesc || '停机'
                                    break
                                case 1:
                                    str = item.runningDesc || '运行'
                                    break
                                case 2:
                                    str = item.warningDesc || '异常'
                                    break
                            }
                            return `${params.seriesName}<br />${params.name}：${str}`
                        }
                    }
                    switchLine.yAxis.axisLabel = {
                         formatter: value => {
                            switch (value) {
                                case 0:
                                    return item.downDesc || '停机'
                                case 1:
                                    return item.runningDesc || '运行'
                                case 2:
                                    return item.warningDesc || '异常'
                                default:
                                    return ''
                            }
                        },
                        color: value => {
                            switch (value) {
                                case '0':
                                    return '#f3b745'
                                case '1':
                                    return '#659ff6'
                                case '2':
                                    return '#f98545'
                            }
                        }

                    }
          chartObj[index] = {
            xAxis: JSON.parse(JSON.stringify(switchLine.xAxis)),
            series: JSON.parse(JSON.stringify(switchLine.series)),
            tooltip: JSON.parse(JSON.stringify(switchLine.tooltip)),
            yAxis: JSON.parse(JSON.stringify(switchLine.yAxis)),
            tip: 'loading'
          };
        } else if (type === 'trendline') {
          let trendlineChart = this.trendlineChart;
          chartObj[index] = {
            xAxis: JSON.parse(JSON.stringify(trendlineChart.xAxis)),
            series: [],
            tip: 'loading'
          };
        }
      });
      this.chartComObj = chartObj;
      this.handleData(this.realTimeData);
      this.reqCapacity();
      this.tip = 'success';
      this.$nextTick(() => {
        let content = this.$refs.content;
        if (content) {
          // this.secureScale =
          //   this.$refs.scaleContainer.clientWidth /
          //   this.$refs.scaleContainer.scrollWidth;
          this.scaleNum =
            this.$refs.scaleContainer.clientWidth /
            this.$refs.scaleContainer.scrollWidth;
          content.addEventListener('DOMMouseScroll', this.handleScroll);
        }
      });
    },
    dimStyle(item) {
      let style = {};
      let len = item.dimension.length;
      let percent = `${100 / len}%`;
      if (item.sortType === 'vertical') {
        style.width = '100%';
        style.height = percent;
      } else {
        style.height = '100%';
        style.width = `calc(${percent} - ${(15 * (len - 1)) / len}px)`;
      }
      return style;
    },
    // 关闭下发值的弹窗

    closeBtnDialog() {
      this.btnValue = '';
      this.btnDialogShow = false;
    },
    //下发值的确定按钮
    setBtnNum(type) {
      if (this.btnValue == null) {
        this.$message.error('请输入值！');
        return;
      }
      if (
        type === 'int' ||
        type === 'float' ||
        type === 'double' ||
        type === 'long'
      ) {
        this.btnValue = Number(this.btnValue);
      }
      this.pressButton(this.btnItem, this.btnValue, type);
    },
    pressButton(item, val, type) {
      // if (this.$store.state.isLoading) {
      //     return;
      // }
      let command_map = {};
      item.rules.forEach(rule => {
        command_map[rule.point.id] = val != null ? val : rule.value;
      });
      this.btnLoading = true;
      this.tipLoading = true;
      issueSave({
        token: this.tokenByRn
          ? this.tokenByRn
          : localStorage.getItem(location.host + 'token') ||
            'ab95fbf7b8754ef085b66292090b1bf2',
        command_map,
        field_type: type
      })
        .then(res => {
          this.btnLoading = false;
          this.tipLoading = false;
          this.tipDialogShow = false;
          this.$message('操作成功！');
          // this.closeLoading();
          if (val != null) {
            this.tempBtnVal[item.rules[0].point.id] = val;
            this.closeBtnDialog();
          }
          // this.$router.replace(this.$route.fulPath);
        })
        .catch(err => {
          this.btnLoading = false;
          this.btnDialogShow = false;
          this.tipLoading = false;
          this.tipDialogShow = false;
          // this.closeLoading();
        });
    },
    // 如果是float或者bouble类型
    formatValue(value) {
      this.btnValue = this.btnValue
        ? this.btnValue.indexOf('.') < 0
          ? Number(this.btnValue).toFixed(1)
          : Number(this.btnValue)
        : '';
    },
    closeTipDialog() {
      this.tipDialogShow = false;
    },
    tipConfirm() {
      this.pressButton(this.tipItem);
    }
  },

  beforeDestroy() {
    clearInterval(this.timer);
    let content = this.$refs.content;
    if (content) {
      this.$refs.content.removeEventListener(
        'DOMMouseScroll',
        this.handleScroll
      );
    }
  },
  watch: {
    scaleNum(val) {
      let scaleNumPercent = Number(Big(val).mul(100));
      if (val < 0.1) {
        this.scaleNum = 0.1;
      }
      // this.scaleNum = 0.1;
    },
    realTimeData(val) {
      this.handleData(val);
    },
    id(val) {
      this.req();
    },
    timestamp(val) {
      if (this.mode === 2) {
        this.reqCapacity({ history_timestamp: val });
      }
    },
    comDataList: {
      handler() {
        this.handlerComDataList();
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/style/mixin';
.panel-container {
  width: 100%;
  -webkit-overflow-scrolling: touch; //实现苹果手机的滚动回弹效果
  display: flex;
  flex-direction: column;
  .nav-btn_left {
    display: block;
    @include wh(vw(44), vw(44));
    background: transparent url('../../assets/images/left_arrow_W.png')
      no-repeat center center;
    background-size: vw(10), vw(18);
  }
}

$c: #1048b0;
$no-break-border: #888;
$online: #00ffcb;
$run: #00ccff;
$breakdown: #ff6c00;
$runStatus: #46ea8d;
$stopStatus: #fff;
$breakStatus: #ff6c00;
$offStatus: #000;
%h-100 {
  height: 100%;
}
%relative {
  position: relative;
}
%absolute {
  position: absolute;
}
%w-100 {
  width: 100%;
}
%h-100 {
  height: 100%;
}
%pointer {
  cursor: pointer;
}
%block {
  display: block;
}
%wh-100 {
  @extend %w-100;
  @extend %h-100;
}
%inherit {
  text-decoration: inherit;
}
%text-ell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
%box {
  box-sizing: border-box;
}
%origin {
  transform-origin: left top;
}
%flex {
  display: flex;
  align-items: center;
}
.new-real-time-container {
  @extend %h-100;
  @extend %relative;
  overflow: scroll;
  padding-bottom: 30px;
}
.new-real-time-content {
  @extend %h-100;
  overflow: auto;
  background-color: #fff;
  &::-webkit-scrollbar-thumb {
    background-color: #ddd;
  }
  padding-right: 20px;
}
.scale-container {
  // min-width: 100%;
  // min-height: 100%;
  @extend %relative;
  @extend %origin;
}
.scale-adjust-container {
  @extend %absolute;
  top: 5px;
  right: 20px;
  background-color: #eee;
  padding: 5px;
  color: #666;
  font-size: 12px;
  border-radius: 4px;
  @extend %flex;
  justify-content: center;
  height: 26px;
  .el-input-number {
    width: 60px;
    @extend %h-100;
    @extend %relative;
    top: -2px;
  }
}
.percent {
  margin-left: 5px;
}
.component-data-container {
  @extend %absolute;
  @extend %pointer;
  @extend %origin;
}
.component-data-content {
  @extend %wh-100;
  @extend %inherit;
  img {
    @extend %block;
  }
}
.com-img-container {
  @extend %wh-100;
  @extend %relative;
  img {
    @extend %wh-100;
    @extend %block;
  }
  svg {
    @extend %wh-100;
    overflow: visible;
    @extend %absolute;
    min-width: 1px;
    min-height: 1px;
    filter: none;
  }
}
.com-text-container {
  @extend %wh-100;
  @extend %box;
  padding: 10px;
  @extend %inherit;
}
.com-text-content {
  // padding: 10px;
  @extend %w-100;
  @extend %text-ell;
  @extend %inherit;
  > span {
    @extend %inherit;
    @extend %relative;
    // top: -1px;
  }
}
.com-border-container {
  @extend %wh-100;
}
.dialog-header {
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #333333;
  border-bottom: 1px solid #dddddd;
}

.dialog-content {
  padding: 20px;
  // background-color: #dfdfdf;
}
.add-select-container {
  margin-bottom: 20px;
  .el-input-number {
    @extend %w-100;
  }
}
.btn-group {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  .el-button {
    border: none;
    @extend %pointer;
    border-radius: 4px;
    width: 30%;
    @extend %h-100;
    color: #666;
    border: 1px solid #999999;
    width: 110px;
    padding: 0;
    font-size: 15px;
    &.save {
      background-color: #3766e1;
      color: #fff;
      border: 1px solid #3766e1;
      margin-left: 10px;
    }
  }
}
.var-container {
  margin-bottom: 20px;
  @extend %text-ell;
}
.com-chart-container {
  @extend %h-100;
  // background-color: #2a2a2a;
  // background-color: rgba(228,240,250,0.3);
  background-color: #f7fafd;
  border-radius: 8px;
  box-shadow: 0px 3px 12px 0px rgba(90, 111, 190, 0.8);
  padding: 10px 15px;
  @extend %box;
}
.chart-title-container {
  @extend %w-100;
  @extend %flex;
  @extend %relative;
  margin-bottom: 10px;
}
.chart-title {
  @extend %w-100;
  @extend %box;
  padding-right: 278px;
  font-weight: bold;
  color: #aaa;
  @extend %text-ell;
}
.com-capacity-container {
  @extend %h-100;
  &:not(.column) {
    .com-capacity-item + .com-capacity-item {
      margin-left: 15px;
    }
  }
}
.com-capacity-item {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  span {
    color: #aaa;
  }
}
.com-capacity-content {
  @extend %w-100;
  border-radius: 4px;
  @extend %flex;
  justify-content: center;
  margin-top: 5px;
  p {
    @extend %w-100;
    @extend %text-ell;
    text-align: center;
  }
}
.time-select-wrap {
  @extend %absolute;
  @extend %h-100;
  right: 0;
  top: 0;
}
.issue-dialog {
  &::v-deep .v-modal {
    background-color: #000;
    opacity: 0.4;
  }
  &::v-deep .el-dialog {
    // background-color: transparent;
    box-shadow: none;
    border-radius: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #ccc;
  }
  &::v-deep .el-dialog__header {
    padding: 0 !important;
    font-size: 15px;
  }
  &::v-deep .el-dialog__body {
    padding: 0 20px !important;
  }
}
.tip-dialog {
  height: 90px;
  padding: 10px 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tip-btn-gruop {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  .el-button {
    @extend %pointer;
    border-radius: 4px;
    // width: 30%;
    @extend %h-100;
    width: 56px;
    padding: 0;
    font-size: 15px;
    &.save {
      margin-left: 10px;
    }
  }
  box-sizing: border-box;
  padding-bottom: 10px;
}
</style>
